"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "font-bold lg:hidden" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "font-bold" };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "font-bold" };
const _hoisted_7 = { key: 2 };
const _hoisted_8 = { class: "font-bold" };
const tagStore_1 = require("../../../stores/tag/tagStore");
const index_1 = require("../../../common/i18n/index");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SizeCell',
    props: {
        product: null
    },
    setup(__props) {
        const tagStore = (0, tagStore_1.useTagStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(tagStore).tags.columns.sizeColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                    key: 0,
                    id: `size-cell-${__props.product.id}`,
                    class: "grid grid-cols-2 border-b border-gray px-4 py-2 lg:table-cell lg:py-1"
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(index_1.trans)('size', 'Size', 'size_cell')), 1),
                    (0, vue_2.createElementVNode)("div", null, [
                        ((0, vue_2.unref)(tagStore).tags.columns.sizeColumn.value === 'spareWheel')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(__props.product.size), 1),
                                (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(__props.product.info), 1)
                            ]))
                            : ((0, vue_2.unref)(tagStore).tags.columns.sizeColumn.value === 'rim')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)(__props.product.size), 1)
                                ]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)(__props.product.size), 1),
                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(__props.product.loadIndex) + (0, vue_2.toDisplayString)(__props.product.speedIndex), 1),
                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(__props.product.info), 1)
                                ]))
                    ])
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
